import { Component, Input, OnChanges, SimpleChanges, ChangeDetectionStrategy } from '@angular/core';
import { trigger, transition, style, animate } from '@angular/animations';

@Component({
    selector: 'app-text-reveal',
    templateUrl: './text-reveal.component.html',
    styleUrls: ['./text-reveal.component.scss'],
    animations: [
        trigger('changeText', [
            transition(':enter', [
                style({ opacity: 0 }),
                animate('0.5s ease-in', style({ opacity: 1 }))
            ])
        ])
    ],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class TextRevealComponent implements OnChanges {
  @Input() textList: { text: string, cssClass: string, backgroundColor: string }[] = [];

  public displayedTextList: { id: number, text: string, cssClass: string, backgroundColor: string, animate: boolean }[] = [];
  private previousTextList: string[] = [];
  private uniqueId = 0;

  ngOnChanges(changes: SimpleChanges) {
    if (changes['textList']) {
      this.updateDisplayedTextList();
    }
  }

  private updateDisplayedTextList() {
    this.displayedTextList = this.textList.map((item, index) => {
      const previousText = this.previousTextList[index];
      const isChanged = !previousText || previousText !== item.text;
      return {
        id: this.uniqueId++,
        text: item.text,
        cssClass: item.cssClass,
        backgroundColor: item.backgroundColor,
        animate: isChanged
      };
    });

    // Güncel metin listesini sakla
    this.previousTextList = this.textList.map(item => item.text);
  }

  trackByFn(index: number, item: any): number {
    return item.id;
  }
}